angular.module('tct.configService', [])
  .factory('configService', configService);

function configService() {
  const factory = {
    APP_ENV: process.env.APP_ENV,
    APP_PROTOCOL: process.env.APP_PROTOCOL,
    APP_API: process.env.APP_API,
    APP_API_PORT: process.env.APP_API_PORT,
    ERR_GENERIC: process.env.ERR_GENERIC,
    SORT_ASC: 'asc',
    SORT_DESC: 'desc',
    FE_APP_PROTOCOL: process.env.FE_APP_PROTOCOL,
    FE_APP_URL: process.env.FE_APP_URL,
  };

  return factory;
}
